export const MAX_ROOM_COUNT_PER_DAY = 1000;

/** Max file size for room/space image uploads (4 MB). Used by ImageUploadField and BizlyOS ImageInputField. */
export const IMAGE_UPLOAD_MAX_BYTES = 1024 * 1024 * 4;

/** Max image upload size in MB (for display in UI). */
export const IMAGE_UPLOAD_MAX_MB = IMAGE_UPLOAD_MAX_BYTES / (1024 * 1024);
